import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { VentaService } from '../../services/venta.service';
import { TranslateService } from 'src/app/shared/services/translate.service';
import { AlbaranItemDialog, AlbaranPausadoDetail, IKoreTarifaDisponible, ITiendaRestItemDialog, VentaPausadaGet } from 'src/app/modules/gestionar-pausadas/interfaces/gestionar-pausadas.interface';
import { VentaPausadaService } from 'src/app/modules/gestionar-pausadas/services/venta-pausada.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { SuccessToast } from 'src/app/core/toast/success.toast';
import { ErrorToast } from 'src/app/core/toast/error.toast';
import { ConfigurationService } from 'src/app/core';
import { Router } from '@angular/router';
import { AppConfiguration } from 'src/app/app.configuration';
import { StepperNavigationService } from '../../services/stepper-navigation.service';
import moment from 'moment';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';


export interface DialogSalePauseDetailData {
  ventapausada: VentaPausadaGet;
}

export interface DialogSalePauseDetailResult {
  confirm: boolean;
  tag: string;
  action?: 'continue' | 'delete';
  rutaDestino?: string;
}

@Component({
  selector: 'dialog-sale-pause-detail',
  templateUrl: 'dialog-sale-pause-detail.component.html',
  styleUrls: ['./dialog-sale-pause-detail.component.scss'],
})
export class DialogSalePauseDetailComponent implements OnInit {
  showMsgError: boolean = false;
  showForm = false;

  ventaPausadaInfo: AlbaranPausadoDetail;
  albaranItems: AlbaranItemDialog[] = [];
  tiendaRestItems: ITiendaRestItemDialog[] = [];
  espectaculosItems: AlbaranItemDialog[] = [];

  subAlbaranPausado: Subscription;

  loading = false;


  divisaSimboloDecimal: string; 
  divisaSimbSeparacionMiles: string;  
  divisaSimbolo: string;
  divisaDecimales: number;
  divisaPosicion: string;
  divisaSimboloDerecha: string;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<DialogSalePauseDetailComponent>,
    private ventaService: VentaService,
    private translateService: TranslateService,
    private ventaPausadaService: VentaPausadaService,
    private toastService: ToastrService,
    private configurationService: ConfigurationService,
    private router: Router,
    private appConfig: AppConfiguration,
    private stepperNavigation: StepperNavigationService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogSalePauseDetailData
  ) {
    console.log({
      dataReceived: data
    });

    //For Test
    this.showForm = true;

    this.loading = true;

    this.subAlbaranPausado = this.ventaPausadaService.getVentaPausadaDetail(data.ventapausada).subscribe(
      (res) => {

        console.log({
          action: 'getVentaPausadaDetail',
          res: res
        })

        this.loading = false;

        if (!res) {

          this.toastService.success(
            this.translateService.instant('ERROR_AVISAR_ENCARGADO'),
            '',
            {
              toastComponent: ErrorToast,
            }
          );

          this.dialogRef.close({
            confirm: false,
            tag: ''
          });

        }


        this.ventaPausadaInfo = res;

        /*
          Se incluirán los siguientes atributos de salida para poder diferenciar entre:
          VISITAS (TipoElemento = 1; CategoriaId > 0; EspectaculoId = 0)
          ESPECTÁCULOS (TipoElemento = 1; CategoriaId > 0, EspectaculoId > 0)
          TIENDA (TipoElemento = 2; CategoriaId > 0)
          RESTAURACION (TipoElemento = 2; CategoriaId > 0)
        
        */

        if (this.ventaPausadaInfo && this.ventaPausadaInfo.albaranItems) {
          for (const item of this.ventaPausadaInfo.albaranItems) {

            let tarifaDisponible: IKoreTarifaDisponible | null = null;

            if (item.tipoElemento === 1) {
              // VISITAS o ESPECTÁCULOS
              if (item.categoriaId > 0 && item.espectaculoId > 0) {
                console.log({
                  item: item,
                  tipo: 'ESPECTÁCULO'
                })
              } else if (item.categoriaId > 0) {
                console.log({
                  item: item,
                  tipo: 'VISITA'
                });
                
                this.ventaPausadaService.getInfoTarifaVisitaEspectaculo(item)
                  .subscribe((tarifa) => {
                    if (tarifa) {
                      this.albaranItems.push({
                        ...item,
                        tarifaDisponible: tarifa
                      })
                      console.log({
                        action: 'get info tarifas',
                        items: this.albaranItems
                      })
                    }
                  }, (error) => {
                    console.error({
                      action: 'getInfoTarifaVisitaEspectaculo',
                      error: error
                    });
                  });
              }
            } else if ((item.tipoElemento === 2 || item.tipoElemento === 3) && item.categoriaId > 0) {
              // TIENDA o RESTAURACIÓN
              console.log({
                item: item,
                tipo: 'TIENDA o RESTAURACIÓN'
              });
              
              this.ventaPausadaService.getInfoTarifaTiendaRestauracion(item)
                .subscribe((entrada) => {
                  if (entrada) {
                    this.tiendaRestItems.push({
                      ...item,
                      entrada: entrada
                    })
                    console.log({
                      action: 'get info tienda restauración',
                      items: this.tiendaRestItems
                    })
                  }
                }, (error) => {
                  console.error({
                    action: 'getInfoTarifaTiendaRestauracion',
                    error: error
                  });
                });
            }
          }
        }
      },
      (error) => {
        console.error({
          action: 'getVentaPausadaDetail',
          error: error
        });
        this.loading = false;
      }
    );

  }

  getPrecioTotalPorItem(item: AlbaranItemDialog | ITiendaRestItemDialog): number {
    const precioTotal = item.precioTotal || 0;
    const cantidad = item.cantidad || 1;
    return Number(precioTotal) * Number(cantidad);
  }

  getCantidadDeItems() {
    const itemsVisitas = this.albaranItems.length;
    const itemsTiendaRest = this.tiendaRestItems.length;
    const itemsEspectaculos = this.espectaculosItems.length;
    return itemsVisitas + itemsTiendaRest + itemsEspectaculos;
  }

  getPrecioFinalTotal(): number {
    return this.ventaPausadaInfo.totalPagar || 0;
  }

  ngOnInit() {
    this.divisaSimbSeparacionMiles = this.configurationService.divisasValue[0].SimbSeparacionMiles;
    this.divisaSimboloDecimal = this.configurationService.divisasValue[0].SimboloDecimal;
    this.divisaSimbolo = this.configurationService.divisasValue[0].simbolo;
    this.divisaDecimales = Number(this.configurationService.divisasValue[0].NumeroDecimales)
    this.divisaPosicion = this.configurationService.divisasValue[0].PosicionDivisa;
    this.divisaSimboloDerecha = this.configurationService.divisasValue[0].SimboloDerecha;
  }

  onNoClick() {

    if (this.subAlbaranPausado) {
      this.subAlbaranPausado.unsubscribe();
    }

    this.dialogRef.close({
      confirm: false,
      tag: ''
    });
  }

  async continuar() {
    if (!this.ventaPausadaInfo) {
      return;
    }

    // Cargar la venta pausada en el carrito (esperar a que termine)
    await this.cargarVentaPausadaEnCarrito();

    // Determinar la ruta de redirección según el tipo de producto
    const rutaDestino = this.determinarRutaDestino();

    // Cerrar el modal con acción continue y ruta destino
    this.dialogRef.close({
      confirm: true,
      tag: this.ventaPausadaInfo.tag || this.data.ventapausada.tag || '',
      action: 'continue',
      rutaDestino: rutaDestino
    });
  }

  eliminar() {
    // Mostrar diálogo de confirmación usando MatDialog
    const confirmDialogRef = this.dialog.open<ConfirmDialogComponent, ConfirmDialogData>(
      ConfirmDialogComponent,
      {
        data: {
          title: 'ALERTA',
          message: 'CONFIRMAR_ELIMINAR_OPERACION_PAUSA',
          confirmText: 'SI',
          cancelText: 'NO'
        },
        disableClose: true,
      }
    );

    confirmDialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        // Cerrar el modal con acción delete
        this.dialogRef.close({
          confirm: true,
          tag: this.ventaPausadaInfo?.tag || this.data.ventapausada.tag || '',
          action: 'delete'
        });
      }
    });
  }

  private async cargarVentaPausadaEnCarrito() {
    if (!this.ventaPausadaInfo) {
      return;
    }

    // Limpiar el carrito
    this.ventaService.clearCarrito();

    // Cargar productos de visitas/espectáculos
    for (const item of this.albaranItems) {
      if (item.tarifaDisponible) {
        const entrada = this.mapAlbaranItemToEntrada(item);
        if (entrada) {
          // Asegurar que recintos esté inicializado
          if (!entrada.recintos) {
            entrada.recintos = [];
          }
          // Asegurar que PromocionEntradas esté inicializado
          if (!entrada.PromocionEntradas) {
            entrada.PromocionEntradas = null;
          }
          this.ventaService.sendEntradas(entrada, item.cantidad);
        }
      }
    }

    // Cargar productos de tienda/restauración
    for (const item of this.tiendaRestItems) {
      if (item.entrada) {
        // Asegurar que recintos esté inicializado para tienda/restauración también
        if (!item.entrada.recintos) {
          item.entrada.recintos = [];
        }
        // Asegurar que PromocionEntradas esté inicializado
        if (!item.entrada.PromocionEntradas) {
          item.entrada.PromocionEntradas = null;
        }
        this.ventaService.sendEntradas(item.entrada, item.cantidad);
      }
    }

    // Configurar fecha si hay entradas
    if (this.ventaService.carritoValue.entradas.length > 0) {
      const primeraEntrada = this.ventaService.carritoValue.entradas[0].entrada;
      if (primeraEntrada.Fecha) {
        this.ventaService.setFechaSeleccionadaValue(moment(primeraEntrada.Fecha));
      }
    }

    // Resetear pasos del stepper
    this.stepperNavigation.desbloquearNavegacionPorPago();
    this.stepperNavigation.continuarVenta.next(false);
    this.stepperNavigation.resetearPasos();
    // NO navegar aquí, se hará después de cerrar el modal en el componente padre
  }

  private determinarRutaDestino(): string {
    // Analizar los tipos de productos cargados
    const tieneTienda = this.tiendaRestItems.some(item => item.tipoElemento === 2);
    const tieneRestauracion = this.tiendaRestItems.some(item => item.tipoElemento === 3);
    const tieneEspectaculo = this.albaranItems.some(item => item.espectaculoId > 0);
    const tieneEntradas = this.albaranItems.some(item => item.tipoElemento === 1 && item.espectaculoId === 0);

    // Determinar ruta según la lógica especificada
    if (tieneTienda && !tieneRestauracion && !tieneEspectaculo && !tieneEntradas) {
      return '/tienda';
    } else if (tieneRestauracion && !tieneTienda && !tieneEspectaculo && !tieneEntradas) {
      return '/restauracion';
    } else if (tieneEspectaculo && !tieneTienda && !tieneRestauracion && !tieneEntradas) {
      return '/auditorio';
    } else if (tieneEntradas && !tieneTienda && !tieneRestauracion && !tieneEspectaculo) {
      return '/venta';
    }

    // Si hay múltiples tipos o no se puede determinar, usar COMPRAINICIO o raíz
    const compraInicio = this.appConfig.getConfig('COMPRAINICIO');
    return compraInicio || '';
  }

  private mapAlbaranItemToEntrada(item: AlbaranItemDialog): any {
    if (!item.tarifaDisponible) {
      return null;
    }

    const tarifa = item.tarifaDisponible;
    
    return {
      ...tarifa,
      TipoEntradaId: tarifa.TipoEntradaId,
      TipoProducto: item.tipoProducto.toString(),
      CategoriaId: item.categoriaId.toString(),
      Fecha: item.fechaHoraEntrada,
      PrecioEnDivisaReferencia: item.precioBase.toString(),
      IVA: item.iva.toString(),
      Comision: item.comision.toString(),
      // Inicializar recintos como array vacío para evitar el error en sendEntradas
      recintos: [],
      // Inicializar PromocionEntradas si es necesario
      PromocionEntradas: item.promocionEntradas || null,
    };
  }

}
